import { Controller } from "@hotwired/stimulus"

const ALLOWED_FIELDS = [
  "title",
  "first_name",
  "surname",
  "address_1",
  "address_2",
  "address_3",
  "address_4",
  "postcode",
  "telephone_number",
  "email_address",
  "card_number",
]

export default class extends Controller {
  static targets = ["field"]

  apply(event) {
    const result = JSON.parse(event.currentTarget.dataset.analysisResult)
    const applicableValues = this.applicableValues(result)
    const replacements = applicableValues.filter(({ field, value }) => {
      return field.value.trim() !== "" && field.value !== value
    })

    if (replacements.length > 0 && !window.confirm(this.confirmationMessage(replacements.length))) {
      return
    }

    applicableValues.forEach(({ field, value }) => {
      field.value = value
      field.classList.remove("address-lookup-applied-field")
      field.classList.add("analysis-applied-field")
      field.title = "Applied from document analysis"
    })
  }

  clearHighlight(event) {
    event.currentTarget.classList.remove("analysis-applied-field")
    event.currentTarget.classList.remove("address-lookup-applied-field")
    event.currentTarget.removeAttribute("title")
  }

  applicableValues(result) {
    return ALLOWED_FIELDS.flatMap((fieldName) => {
      const value = result[fieldName]?.value
      const field = this.fieldTargets.find((target) => target.dataset.analysisField === fieldName)

      if (!field || value === null || value === undefined || String(value).trim() === "") {
        return []
      }

      return [{ field, value: String(value) }]
    })
  }

  confirmationMessage(replacementCount) {
    const noun = replacementCount === 1 ? "field" : "fields"
    return `Applying this analysis will replace ${replacementCount} nonblank ${noun}. Continue?`
  }
}
